(function () {
  'use strict';

  function getHeaderOffset() {
    var header =
      document.querySelector('.header') ||
      document.querySelector('[data-section-type="header"]') ||
      document.querySelector('header');
    if (!header) return 0;
    return Math.round(header.getBoundingClientRect().height) || 0;
  }

  function getScrollGap(section) {
    var gap = section.getAttribute('data-scroll-gap');
    var parsedGap = gap !== null && gap !== '' ? parseInt(gap, 10) : 12;
    return isNaN(parsedGap) ? 12 : parsedGap;
  }

  function setStickyOffset(section) {
    var top = section.getAttribute('data-sticky-offset');
    var parsed = top !== null && top !== '' ? parseInt(top, 10) : NaN;
    var offset = !isNaN(parsed) && parsed > 0 ? parsed : getHeaderOffset();
    section.style.setProperty('--pts-sticky-top', offset + 'px');
    return offset;
  }

  function updateScrollOffset(section) {
    var stickyTop = setStickyOffset(section);
    var navWrap = section.querySelector('.product-tabs-sauna__desktop .product-tabs-sauna__nav-wrap');
    var navHeight = navWrap ? Math.round(navWrap.offsetHeight) : 72;
    var gap = getScrollGap(section);
    var scrollOffset = stickyTop + navHeight + gap;

    section.style.setProperty('--pts-nav-height', navHeight + 'px');
    section.style.setProperty('--pts-scroll-gap', gap + 'px');
    section.style.setProperty('--pts-scroll-offset', scrollOffset + 'px');

    return scrollOffset;
  }

  function scrollToPanel(panel, section) {
    var anchor = panel.querySelector('.product-tabs-sauna__scroll-anchor');
    if (!anchor) return;

    var offset = updateScrollOffset(section);

    var top = anchor.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({
      top: Math.max(0, Math.round(top)),
      behavior: 'smooth',
    });
  }

  function scrollToExternalTarget(target, section) {
    var offset = updateScrollOffset(section);
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({
      top: Math.max(0, Math.round(top)),
      behavior: 'smooth',
    });
  }

  function resolveTarget(anchor) {
    if (!anchor) return null;
    var id = anchor.replace(/^#/, '').trim();
    if (!id) return null;
    return (
      document.getElementById(id) ||
      document.querySelector('[data-section-id="' + id + '"]') ||
      document.querySelector('#shopify-section-' + id)
    );
  }

  function initNav(section) {
    var desktop = section.querySelector('.product-tabs-sauna__desktop');
    if (!desktop) return;

    var navLinks = desktop.querySelectorAll('[data-pts-nav]');
    var panels = desktop.querySelectorAll('[data-pts-panel]');
    if (!navLinks.length) return;

    navLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var anchor = link.getAttribute('data-target');
        var target = resolveTarget(anchor);

        if (target && target.matches('[data-pts-panel]')) {
          scrollToPanel(target, section);
        } else if (target) {
          scrollToExternalTarget(target, section);
        }

        navLinks.forEach(function (l) {
          l.classList.remove('is-active');
        });
        link.classList.add('is-active');
      });
    });

    if (!('IntersectionObserver' in window) || !panels.length) return;

    var scrollMargin = updateScrollOffset(section);

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var id = entry.target.id;
          navLinks.forEach(function (link) {
            var target = link.getAttribute('data-target') || '';
            link.classList.toggle('is-active', target.replace(/^#/, '') === id);
          });
        });
      },
      {
        rootMargin: '-' + scrollMargin + 'px 0px -55% 0px',
        threshold: 0,
      }
    );

    panels.forEach(function (panel) {
      observer.observe(panel);
    });
  }

  function initAccordion(section) {
    // Non-exclusive: tapping a header toggles only its own item and never closes
    // the others. A panel only ever adds/removes height BELOW its own trigger, so
    // the tapped header keeps its viewport position -> no scroll jump (this was
    // the root cause of the old exclusive accordion's disorienting jump).
    section.querySelectorAll('[data-pts-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-pts-accordion-item]');
        if (!item) return;
        var willOpen = !item.classList.contains('is-open');
        item.classList.toggle('is-open', willOpen);
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });
  }

  var PTS_DESKTOP_MQ = '(min-width: 1000px)';

  function initMontageSliders(section) {
    section.querySelectorAll('[data-pts-montage]').forEach(function (root) {
      var track = root.querySelector('[data-pts-montage-track]');
      if (!track) return;

      var slides = track.querySelectorAll('[data-pts-montage-slide]');
      if (slides.length < 2) return;

      var index = 0;
      var desktopMq = window.matchMedia(PTS_DESKTOP_MQ);

      function isDesktopMode() {
        return desktopMq.matches;
      }

      function getSlideScrollLeft(i) {
        var slide = slides[i];
        return slide ? slide.offsetLeft - track.offsetLeft : 0;
      }

      function applyDesktopState() {
        slides.forEach(function (slide, idx) {
          slide.classList.toggle('is-active', idx === index);
        });
      }

      function scrollToSlide(i, behavior) {
        index = (i + slides.length) % slides.length;
        if (isDesktopMode()) {
          applyDesktopState();
          return;
        }
        track.scrollTo({
          left: getSlideScrollLeft(index),
          behavior: behavior || 'smooth',
        });
      }

      function show(i, behavior) {
        scrollToSlide(i, behavior);
      }

      function syncIndexFromScroll() {
        if (isDesktopMode()) return;
        var scrollLeft = track.scrollLeft;
        var closest = 0;
        var minDist = Infinity;
        slides.forEach(function (slide, i) {
          var dist = Math.abs(getSlideScrollLeft(i) - scrollLeft);
          if (dist < minDist) {
            minDist = dist;
            closest = i;
          }
        });
        index = closest;
      }

      track.addEventListener(
        'scroll',
        function () {
          if (isDesktopMode()) return;
          syncIndexFromScroll();
        },
        { passive: true }
      );

      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-pts-montage-prev]')) {
          e.preventDefault();
          show(index - 1);
        }
        if (e.target.closest('[data-pts-montage-next]')) {
          e.preventDefault();
          show(index + 1);
        }
      });

      function onBreakpointChange() {
        if (isDesktopMode()) {
          applyDesktopState();
          return;
        }
        show(index, 'auto');
      }

      if (typeof desktopMq.addEventListener === 'function') {
        desktopMq.addEventListener('change', onBreakpointChange);
      } else if (typeof desktopMq.addListener === 'function') {
        desktopMq.addListener(onBreakpointChange);
      }

      onBreakpointChange();
    });
  }

  function initAddToCart(section) {
    section.querySelectorAll('[data-pts-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
        if (!variantId || btn.disabled || btn.classList.contains('is-loading')) return;

        btn.classList.add('is-loading');
        var base = window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add';
        var addUrl = base.indexOf('.js') !== -1 ? base : base + '.js';

        fetch(addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw data;
              return data;
            });
          })
          .then(function (data) {
            document.documentElement.dispatchEvent(
              new CustomEvent('product:added', {
                bubbles: true,
                detail: { variant: data, quantity: 1 },
              })
            );
          })
          .catch(function () {
            /* silent */
          })
          .finally(function () {
            btn.classList.remove('is-loading');
          });
      });
    });
  }

  function initSection(section) {
    if (!section || section.getAttribute('data-pts-initialized') === 'true') return;
    section.setAttribute('data-pts-initialized', 'true');
    updateScrollOffset(section);
    initNav(section);
    initAccordion(section);
    initMontageSliders(section);
    initAddToCart(section);
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="product-tabs-sauna"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-section-type="product-tabs-sauna"]') || e.target;
    if (section && section.matches && section.matches('[data-section-type="product-tabs-sauna"]')) {
      section.removeAttribute('data-pts-initialized');
      initSection(section);
    }
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-section-type="product-tabs-sauna"]').forEach(updateScrollOffset);
  });
})();
